import ClubMemberAccessMediumAssignmentJob from '../dto/ClubMemberAccessMediumAssignmentJob';
import Error from '../model/Error';
import axios from 'axios';

export default class ClubMemberAccessMediumAssignmentJobRepository {
    static add(memberId) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/members/${memberId}/access-mediums/assignment-jobs`)
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static find(memberId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/members/${memberId}/access-mediums/assignment-jobs`)
                .then((response) => resolve(ClubMemberAccessMediumAssignmentJob.fromData(response.data.data)))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static delete(memberId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/members/${memberId}/access-mediums/assignment-jobs`)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
